//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



import UMUM from  '../../library/umum'


export default {
  data() {
    return {
      listData: [],
      listKegiatan : [],


      UMUM : UMUM
    };
  },
  methods: {
    getKegiatan(){
      fetch(this.$store.state.url.URL_CNT_KEGIATAN_TERBARU + "list5", {
          method: "GET",
          headers: {
          "content-type": "application/json",
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.listKegiatan = res_data
              // console.log(res_data);
      });
    },



  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    this.$store.commit('getOne')
    this.getKegiatan();
  },
};
